import { render, staticRenderFns } from "./ComplexShadow.vue?vue&type=template&id=15223838"
import script from "./ComplexShadow.vue?vue&type=script&lang=js"
export * from "./ComplexShadow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports